<template>
  <div class="wechat-callback">
    <el-card class="callback-card">
      <div class="callback-content">
        <i class="el-icon-loading" style="font-size: 48px; color: #07c160;"></i>
        <p class="callback-text">微信登录处理中...</p>
        <p class="callback-hint">请稍候，正在为您完成登录</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'WechatCallback',
  mounted() {
    this.handleCallback()
  },
  methods: {
    async handleCallback() {
      try {
        // 从URL获取code和state参数
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')
        const state = urlParams.get('state')
        
        if (!code) {
          this.sendMessageToParent('wechat_login_failed', '授权失败：未获取到授权码')
          return
        }
        
        // 调用后端接口处理微信回调
        const res = await this.$axios.post('/auth/wechat/login', {
          code: code,
          state: state
        })
        
        if (res.data.code === 200) {
          // 登录成功，向父窗口发送消息
          this.sendMessageToParent('wechat_login_success', res.data.data)
        } else {
          this.sendMessageToParent('wechat_login_failed', res.data.message || '登录失败')
        }
      } catch (error) {
        console.error('微信回调处理错误:', error)
        this.sendMessageToParent('wechat_login_failed', '登录失败：' + (error.message || '未知错误'))
      }
    },
    
    sendMessageToParent(type, data) {
      // 向父窗口发送消息
      if (window.opener) {
        window.opener.postMessage({
          type: type,
          data: data,
          message: typeof data === 'string' ? data : ''
        }, window.location.origin)
        
        // 延迟关闭窗口
        setTimeout(() => {
          window.close()
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.wechat-callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(7, 193, 96, 0.1) 0%, rgba(7, 187, 7, 0.1) 100%);
}

.callback-card {
  width: 100%;
  max-width: 500px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}

.callback-content {
  text-align: center;
  padding: 40px 20px;
}

.callback-text {
  margin-top: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.callback-hint {
  margin-top: 10px;
  font-size: 14px;
  color: #909399;
}
</style>
